module.exports = __webpack_public_path__ + "stacked-boxes.ad8faadd53ccc0f3c5aceb93e7c1e31a.svg";